import React from 'react';

import {
  useCreateFinancialResult,
  useEditFinancialResult,
  useLoadFinancialResult,
} from 'scenes/FinancialResults/data';

import FinancialResultForm from './FinancialResultForm';
import { ATTACHMENTS, INVOICES } from './constants';
import getEditAction from './editActionsGranularity';

export const FinancialResultFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createFinancialResult, { isLoading: loading }] =
    useCreateFinancialResult();

  const handleSubmit = async (values) => {
    let result = await createFinancialResult(values);
    onSubmit(result);
  };

  return (
    <FinancialResultForm
      title={'Add Financial Result'}
      loading={loading}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};

export const FinancialResultFormEdit = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [editFinancialResult, { isLoading: loading }] =
    useEditFinancialResult();
  const { data, isLoading } = useLoadFinancialResult({ id });

  const actions = data?.editGranularity
    ? getEditAction(data.editGranularity)
    : [];

  const handleSubmit = async (values) => {
    let result = await editFinancialResult(values);
    onSubmit(result);
  };

  return (
    <FinancialResultForm
      title={'Edit Financial Result'}
      entityId={id}
      actions={actions}
      loading={isLoading || loading}
      active={!!data}
      initialValues={data}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
      isEdit
    />
  );
};

export const FinancialResultFormDuplicate = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [createFinancialResult, { isLoading: loading }] =
    useCreateFinancialResult();

  const { data, isLoading } = useLoadFinancialResult({ id });

  const {
    id: _,
    [INVOICES]: __,
    [ATTACHMENTS]: ___,
    ...duplicatedData
  } = data || {};

  const handleSubmit = async (values) => {
    let result = await createFinancialResult(values);
    onSubmit(result);
  };

  return (
    <FinancialResultForm
      title={'Add Financial Result'}
      loading={isLoading || loading}
      active={!!data}
      initialValues={duplicatedData}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};
